import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { dekalbConfig } from "./data";

export default function DekalbPage() {
  return <CityPageTemplate config={dekalbConfig} />;
}